export default __webpack_public_path__ + "../staticImages/cheers_glaeser-260.png";